import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { DocumentCaptureBase } from '../document-capture-base.component';
import { DocumentCaptureFooterComponent } from '../document-capture-footer/document-capture-footer.component';

@Component({
  selector: 'app-ncb-transfer-declaration',
  imports: [ReactiveFormsModule, DocumentCaptureFooterComponent],
  templateUrl: './ncb-transfer-declaration.component.html',
  styleUrl: './ncb-transfer-declaration.component.scss',
})
export class NcbTransferDeclarationComponent extends DocumentCaptureBase {
  constructor(private fb: FormBuilder) {
    super();
  }

  ncbForm = this.fb.group({
    ncbConfirmed: [false, Validators.requiredTrue],
  });

  onChange() {
    const isChecked = !!this.ncbForm.controls.ncbConfirmed.value;
    this.document.value = isChecked ? 'true' : '';

    if (!this.document.keyValues) {
      this.document.keyValues = [];
    }
    const existingIndex = this.document.keyValues.findIndex(
      (kv) => kv.key === 'ncbTransferDeclaration'
    );
    if (existingIndex > -1) {
      this.document.keyValues[existingIndex].value = isChecked ? 'true' : 'false';
    } else {
      this.document.keyValues.push({
        key: 'ncbTransferDeclaration',
        value: isChecked ? 'true' : 'false',
      });
    }

    this.document.enableSubmitButton = isChecked;
    this.onChanged.emit(this.document);
  }
}

